import Vue from 'vue'
import BackToTop from './BackToTop'

// register globally
Vue.component('backto-top', BackToTop)
